/* eslint-disable no-unused-vars */
import { useMutation } from 'react-query';
import { useNotification } from 'src/providers/notificationsProvider';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { UseAddContentModelMutationParams } from '../contentModels/mutations/useAddContntModelMutation/interfaces/useAddContentModelMutation.interface';

const deleteNotification = async (data: number) => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  // @ts-ignore
  //   if (!currentProject?._id) return;

  //   getClient()?.deleteEntity(currentProject?._id, data);
};

export const useDeleteNotification = ({ onError, onSuccess }: UseAddContentModelMutationParams) => {
  const { notify } = useNotification();

  return useMutation((data: number) => deleteNotification(data), {
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      notify({ message: 'Notification Created Successfully' });
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
